import global from './global/lang.he';
import main from './pages/main/lang.he';
import login from './pages/login/lang.he';
import forgot from './pages/forgot/lang.he';
import reset from './pages/reset/lang.he';
import error from './pages/error/lang.he';
import agents from './pages/agents/lang.he';
import agentsArchived from './pages/agentsArchived/lang.he';
import archivedExpensesAgent from './pages/archivedExpensesAgent/lang.he';
import users from './pages/users/lang.he';
import userview from './pages/userView/lang.he';
import usercreate from './pages/userCreate/lang.he';
import useredit from './pages/userEdit/lang.he';
import settings from './pages/settings/lang.he';
import agentEdit from './pages/agentEdit/lang.he';
import agentview from './pages/agentView/lang.he';
import uploads from './pages/uploads/lang.he';
import agentcreate from './pages/agentCreate/lang.he';
import reports from './pages/reports/lang.he';
import agencyCommissions from './pages/agencyCommissions/lang.he';
import agencyCommissionsCreate from './pages/agencyCommissionsCreate/lang.he';
import agencyCommissionsView from './pages/agencyCommissionsView/lang.he';
import agencyCommissionsEdit from './pages/agencyCommissionsEdit/lang.he';
import importLang from './pages/import/lang.he';
import navbar from './components/navbar/lang.he';
import filter from './components/filter/lang.he';
import columns from './components/columns/lang.he';
import exportLang from './components/export/lang.he';
import comments from './components/comments/lang.he';
import history from './components/history/lang.he';
import rows from './components/rows/lang.he';
import files from './components/files/lang.he';
import usericon from './components/userIcon/lang.he';
import table from './components/table/lang.he';
import validations from './validations/lang.he';
import errorFallback from './components/errorFallback/lang.he';
import chart from './components/chart/lang.he';
import favorites from './components/favorites/lang.he';
import messages from './components/messages/lang.he';
import processNotification from './components/processNotification/lang.he';
import editClients from './components/editClients/lang.he';
import editAlternativeFunds from './components/editAlternativeFunds/lang.he';
import editContracts from './components/editContracts/lang.he';
import editAgentDetails from './components/editAgentDetails/lang.he';
import editExpenses from './components/editExpenses/lang.he';
import createContracts from './components/createContracts/lang.he';
import createClients from './components/createClients/lang.he';
import createAlternativeFunds from './components/createAlternativeFunds/lang.he';
import createAgentDetails from './components/createAgentDetails/lang.he';
import viewAgentAgreements from './components/viewAgentAgreements/lang.he';
import viewAgentDetails from './components/viewAgentDetails/lang.he';
import viewAgentFiles from './components/viewAgentFiles/lang.he';
import viewAgentClients from './components/viewAgentClients/lang.he';
import viewAgentAlternativeFunds from './components/viewAgentAlternativeFunds/lang.he';
import viewAgentExpenses from './components/viewAgentExpenses/lang.he';
import customDropZone from './components/customDropZone/lang.he';
import createAgentAgreementInProcess from './components/createAgentAgreementInProcess/lang.he';
import createAgentInProcess from './components/createAgentInProcess/lang.he';
import doneCreatingInProcess from './components/doneCreatingInProcess/lang.he';
import createAgentClientInProcess from './components/createAgentClientInProcess/lang.he';
import createAgentAlternativeFundInProcess from './components/createAgentAlternativeFundInProcess/lang.he';
import agencyCommissionsSwitch from './components/agencyCommissionsSwitch/lang.he';
import reportView from './pages/reportsView/lang.he';
import email from './components/email/lang.he';
import addAgentAgreement from './components/addAgentAgreement/lang.he';
import filesPage from './pages/files/lang.he';
import viewAgentEmails from './components/viewAgentEmails/lang.he';
import viewAgentCommissions from './components/viewAgentCommissions/lang.he';
import viewAgentAdditionalFees from './components/viewAgentAdditionalFees/lang.he';
import createAgentExpense from './components/createAgentexpense/lang.he';
import createAgentAdditionalFee from './components/createAgentAdditionalFee/lang.he';
import editAdditionalFee from './components/editAdditionalFee/lang.he';
import viewAgentArchiveFees from './pages/viewAgentArchiveFees/lang.he';
import viewAgentArchivedEmails from './pages/viewAgentArchivedEmails/lang.he';
import monthlyPayment from './pages/monthlyPayment/lang.he';
import agentCommisions from './components/agentCommisions/lang.he';
import paymentConfirmation from './pages/paymentConfirmation/lang.he';
import viewPaymentProof from './components/viewPaymentProof/lang.he';
import paymentProofEdit from './components/paymentProofEdit/lang.he';
import rowErrorsModal from './components/rowErrorsModal/lang.he';
import reassignAgentModal from './components/reassignAgentModal/lang.he';
import eventDrawer from './components/eventDrawer/lang.he';
import fileCommissionDeviations from './pages/fileCommissionDeviations/lang.he';
import tieredCommissionInput from './components/tieredCommissionInput/lang.he';
import events from './pages/events/lang.he';

export default {
  global,
  validations,

  components: {
    navbar,
    filter,
    export: exportLang,
    columns,
    comments,
    history,
    files,
    usericon,
    viewAgentAgreements,
    table,
    errorFallback,
    rows,
    chart,
    favorites,
    messages,
    processNotification,
    editClients,
    editAlternativeFunds,
    editContracts,
    editAgentDetails,
    createContracts,
    createClients,
    createAlternativeFunds,
    createAgentDetails,
    viewAgentDetails,
    viewAgentFiles,
    viewAgentClients,
    viewAgentAlternativeFunds,
    viewAgentExpenses,
    customDropZone,
    editExpenses,
    createAgentAgreementInProcess,
    createAgentInProcess,
    doneCreatingInProcess,
    createAgentClientInProcess,
    createAgentAlternativeFundInProcess,
    agencyCommissionsSwitch,
    email,
    addAgentAgreement,
    viewAgentEmails,
    viewAgentCommissions,
    viewAgentAdditionalFees,
    createAgentExpense,
    createAgentAdditionalFee,
    editAdditionalFee,
    agentCommisions,
    viewPaymentProof,
    paymentProofEdit,
    rowErrorsModal,
    reassignAgentModal,
    eventDrawer,
    tieredCommissionInput,
  },

  pages: {
    main,
    login,
    forgot,
    error,
    agents,
    agentsArchived,
    archivedExpensesAgent,
    agentEdit,
    agentview,
    agentcreate,
    users,
    userview,
    usercreate,
    useredit,
    reset,
    settings,
    reports,
    uploads,
    agencyCommissions,
    agencyCommissionsCreate,
    agencyCommissionsView,
    agencyCommissionsEdit,
    reportView,
    filesPage,
    import: importLang,
    viewAgentArchiveFees,
    viewAgentArchivedEmails,
    monthlyPayment,
    paymentConfirmation,
    fileCommissionDeviations,
    events,
  },
};
